import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faBars, faTimes,faEnvelope } from '@fortawesome/free-solid-svg-icons';
import '../../assets/styles/Header.css';

const Header = ({ isSidebarOpen, toggleSidebar, staySidebarOpen, toggleStaySidebarOpen }) => {
  const { user } = useAuth();
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate(); // Use navigate for navigation

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const getArticle = (role) => {
    if (!role) return '';
    const vowels = ['a', 'e', 'i', 'o', 'u'];
    return vowels.includes(role[0].toLowerCase()) ? 'an' : 'a';
  };

  const handleNotificationClick = () => {
    const roleForNavigation = (user.role === 'super-admin' || user.role === 'admin') ? 'admin' : user.role;
    navigate(`/${roleForNavigation}/notifications`);
  };

  return (
    <header className="dashboard-header">
      <div className="header-content">
        <div className="welcome-message">
          <h1>SMS</h1>
        </div>
        <div className="header-actions">
          <div className="notifications">
            {user && (
              <FontAwesomeIcon
                icon={faEnvelope}
                className="fa-icon bell-icon"
                onClick={handleNotificationClick} // Add click handler
              />
            )}
          </div>
          <div className="user-profile">
            {user ? (
              <>
                <span className="welcome-text">
                  {user.firstName} {getArticle(user.role)} {user.role}
                </span>
              </>
            ) : (
              <span></span>
            )}
            <div className="sidebar-toggle" onClick={toggleSidebar}>
              <FontAwesomeIcon icon={isSidebarOpen ? faTimes : faBars} className="fa-icon" />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
